import css from "styled-jsx/css";
import Colors from "styles/colors";
import { getComponentShadow, getComponentShadowWithHoverEffect } from "segments/desktop/constants";
import { BLACK_COLOR_NAME } from "styles/color-consts";

export const componentStyles = css`
  .card-grid-link {
    text-decoration: none;
    color: ${Colors[BLACK_COLOR_NAME]};
    height: 100%;

    &.without-link {
      .grid-paragraph-with-image {
        cursor: initial;
      }
    }

    .grid-paragraph-with-image {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      cursor: pointer;
      border-radius: 18px;
      background-color: var(--card-color);
      overflow: hidden;

      &:hover {
        ${getComponentShadow()}
      }

      // remove hover effect in safari because of this bug: https://monday.monday.com/boards/757661511/pulses/2181485781
      @media not all and (min-resolution: 0.001dpcm) {
        @supports (-webkit-appearance: none) {
          &:hover {
            filter: none;
          }
        }
      }

      :global(.grid-image-wrapper) {
        :global(.grid-image) {
          :global(.picture-component) {
            display: flex;
            :global(img) {
              border-bottom-right-radius: 16px;
              border-bottom-left-radius: 16px;
            }
          }
        }
      }

      &.shadow {
        ${getComponentShadow()}
        &:hover {
          ${getComponentShadowWithHoverEffect()}
        }
      }

      .grid-paragraph-wrapper {
        height: 100%;
        padding: 24px 24px 40px 24px;
      }
    }
  }
`;
